export default "__VITE_ASSET__BJYMEoFS__"